import GetApi from '../api/get'

export function setState(params) {
  return {
    type: 'SET_STATE_SEARCH',
    params: params
  }
}

export function get (params) {
  return async (dispatch, getState) => {
    const getApi = new GetApi()
    await getApi.execute(routeUrlHelper.searchPath(), params).then((res) => {
      dispatch(setState(res.body))
    }).catch((res) => {
    })
  }
}
